import { Component } from '@angular/core';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import {
  KPI_PANEL_IMPORTS,
  KpiPanelComponent,
} from '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.scss',
  selector: 'app-total-energy-used-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class TotalElectricityUsedKpiPanelComponent extends KpiPanelComponent {
  public static override readonly type = PanelType.TotalEnergyUsedKpi;
  public override title = 'Verbruik uit het elektriciteitsnet';
  public override icon = 'bi-lightning-charge-fill';
  public override unit = DisplayUnit.Kwh;
}
